<template>
  <div>
    <template v-if="!hideAppbar">
      <opq-basic-appbar v-if="!hideAppbar">{{ title }}</opq-basic-appbar>
    </template>
    <div class="text-center d-flex align-center" id="content" :style="{ height }">
      <div class="mx-auto">
        <div class="animation-ctn">
          <div class="icon icon--order-success svg">
            <svg xmlns="http://www.w3.org/2000/svg" width="154px" height="154px">
              <g fill="none" stroke="#22AE73" stroke-width="2">
                <circle cx="77" cy="77" r="72" style="stroke-dasharray: 480px, 480px; stroke-dashoffset: 960px"></circle>
                <circle id="colored" fill="#22AE73" cx="77" cy="77" r="72" style="stroke-dasharray: 480px, 480px; stroke-dashoffset: 960px"></circle>
                <polyline
                  class="st0"
                  stroke="#fff"
                  stroke-width="10"
                  points="43.5,77.8 63.7,97.9 112.2,49.4 "
                  style="stroke-dasharray: 100px, 100px; stroke-dashoffset: 200px"
                />
              </g>
            </svg>
          </div>
        </div>
        <div class="fade-in">
          <div>
            <v-sheet max-width="1000">
              <slot></slot>
              <p v-if="message">{{ message }}</p>
            </v-sheet>
          </div>
          <template v-if="idFacture">
            <v-btn class="my-3" color="primary" x-large :to="{ path: '/payer-une-facture/' + idFacture }">Paiement en ligne</v-btn>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppbarBase from "@/mixins/AppbarBase"
export default {
  mixins: [AppbarBase],
  props: {
    title: String,
    hideAppbar: {
      type: Boolean,
      default: false
    },
    idFacture: { type: String },
    message: String
  },
  computed: {
    height() {
      if (this.hideAppbar) {
        return "50vh"
      } else {
        return "calc(100vh - " + this.appbarHeight + "px" + ")"
      }
    }
  }
}
</script>

<style scoped>
.animation-ctn {
  text-align: center;
}

@keyframes checkmark {
  0% {
    stroke-dashoffset: 100px;
  }

  100% {
    stroke-dashoffset: 200px;
  }
}

@keyframes checkmark-circle {
  0% {
    stroke-dashoffset: 480px;
  }

  100% {
    stroke-dashoffset: 960px;
  }
}

@keyframes colored-circle {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 100;
  }
}
.fade-in {
  animation: colored-circle 0.6s ease-in-out 1.45s backwards;
}
.inlinesvg .svg svg {
  display: inline;
}

.icon--order-success svg polyline {
  animation: checkmark 0.25s ease-in-out 0.7s backwards;
}

.icon--order-success svg circle {
  animation: checkmark-circle 0.6s ease-in-out backwards;
}
.icon--order-success svg circle#colored {
  animation: colored-circle 0.6s ease-in-out 0.7s backwards;
}
</style>